<template>
  <v-main>
    <v-container fluid>
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

      <v-card>
        <v-card-title>
          Layanan Superior
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Cari berdasarkan nama"
            single-line
            hide-details
            @keyup.enter="getDataFromApi"
          ></v-text-field>
          <v-spacer></v-spacer>

          <v-dialog v-model="dialog" persistent max-width="600px">
            <template #activator="{}">
              <v-btn color="primary" dark @click="doAdd"> Tambah </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">Data Layanan</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="currentData.name"
                        label="Nama"
                        required
                        outlined
                        dense
                      ></v-text-field>
                      <v-textarea
                        v-model="currentData.description"
                        outlined
                        label="Deskripsi"
                        rows="4"
                        required
                        row-height="15"
                      ></v-textarea>
                      <v-text-field
                        v-model="currentData.name_en"
                        label="Nama Inggris"
                        required
                        outlined
                        dense
                      ></v-text-field>
                      <v-textarea
                        v-model="currentData.description_en"
                        outlined
                        label="Deskripsi Inggris"
                        rows="4"
                        required
                        row-height="15"
                      ></v-textarea>
                      <v-sheet v-if="showImage" color="white" elevation="2">
                        <div style="width: 100%">
                          <v-img
                            :key="fotoKey"
                            :src="currentData.FotoUrl"
                            contain
                            width="100%"
                          ></v-img>
                        </div>
                      </v-sheet>
                      <v-file-input
                        v-model="currentData.file_foto"
                        accept="image/*"
                        prepend-icon="mdi-image"
                        show-size
                        label="Foto"
                        @change="loadImage"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closePopUp">
                  Close
                </v-btn>
                <v-btn color="blue darken-1" text @click="doSave"> Save </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5"
                >Apa anda akan menghapus data ini?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Tidak</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >Ya</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-title>
        <div class="pb-6 px-4">
          <v-data-table
            v-model="selected"
            :options.sync="options"
            :headers="headers"
            :items="list_data"
            :server-items-length="totalData"
            :loading="loading"
            class="elevation-1"
            :single-select="true"
            show-select
          >
            <template #[`item.actions`]="{ item }">
              <div class="d-flex">
                <v-icon medium class="mr-3" @click="editItem(item)">
                  mdi-pencil
                </v-icon>
                <v-icon medium class="mr-2" @click="deleteItem(item)">
                  mdi-delete
                </v-icon>
              </div>
            </template>
          </v-data-table>
        </div>
      </v-card>

      <v-card class="mt-4">
        <LayananSuperiorLayanan
          v-if="selected.length > 0"
          :id="selected[0].id"
          ref="mychild"
          :key="childKey"
        />
      </v-card>
    </v-container>
  </v-main>
</template>

<script setup>
import { ref, reactive, watch, onMounted, nextTick } from "vue";
import LayananSuperiorService from "../../services/LayananSuperiorService";
import CommonService from "../../services/CommonService";
import LayananSuperiorLayanan from "./LayananSuperiorLayanan.vue";

// Component's reactive state
const breadcrumbs = ref([
  {
    text: "Master",
    disabled: false,
    href: "master-layanan-superior",
  },
  {
    text: "Layanan Superior",
    disabled: true,
  },
]);
const childKey = ref(0);
const selected = ref([]);
const search = ref("");
const headers = ref([
  { text: "No", align: "start", sortable: false, value: "no" },
  { text: "Nama", value: "nama", sortable: false },
  { text: "Deskripsi", value: "deskripsi", sortable: false },
  {
    text: "Actions",
    value: "actions",
    align: "end",
    sortable: false,
    class: "actions-header",
  },
]);
const showImage = ref(false);
const isFirst = ref(false);
const totalData = ref(0);
const list_data = ref([]);
const loading = ref(true);
const options = ref({ itemsPerPage: 5 });
const editedIndex = ref(-1);
const editedItem = ref({});
const dialog = ref(false);
const dialogDelete = ref(false);
const fotoKey = ref(0);
const mychild = ref(null); // Template ref for child component

const defaultItem = {
  id: null,
  name: "",
  description: "",
  name_en: "",
  description_en: "",
  FotoUrl: null,
  file_foto: null,
};
const currentData = reactive({ ...defaultItem });

// --- Methods ---

const getDataFromApi = () => {
  const { page, itemsPerPage } = options.value;
  loading.value = true;
  LayananSuperiorService.layananList(page, itemsPerPage, search.value)
    .then((res) => {
      list_data.value = res.data.list_data;
      totalData.value = res.data.total;
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() => {
      loading.value = false;
      isFirst.value = true;
    });
};

const loadImage = (file) => {
  if (file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      currentData.FotoUrl = e.target.result;
      fotoKey.value++;
    };
    reader.readAsDataURL(file);
  } else {
    currentData.FotoUrl = "";
    currentData.file_foto = null;
  }
};

const resetCurrentData = () => {
  Object.assign(currentData, defaultItem);
  fotoKey.value = 0;
};

const doAdd = () => {
  resetCurrentData();
  showImage.value = true;
  dialog.value = true;
};

const doSave = async () => {
  if (!currentData.name) {
    alert("Nama harus diisi.");
    return;
  }

  try {
    if (currentData.id == null) {
      // Create new
      await LayananSuperiorService.create(currentData, currentData.file_foto);
      CommonService.showSuccessToast("Tambah data layanan berhasil");
    } else {
      // Update existing
      await LayananSuperiorService.update(
        currentData.id,
        currentData,
        currentData.file_foto,
      );
      CommonService.showSuccessToast("Update data layanan berhasil");
    }
    dialog.value = false;
    resetCurrentData();
    getDataFromApi();
  } catch (err) {
    console.error(err);
    const action = currentData.id ? "Update" : "Tambah";
    CommonService.showErrorToast(`${action} data layanan gagal. Coba lagi`);
  }
};

const editItem = (item) => {
  editedIndex.value = list_data.value.indexOf(item);
  editedItem.value = { ...item };

  currentData.id = item.id;
  currentData.name = item.nama;
  currentData.description = item.deskripsi;
  currentData.name_en = item.nama_en;
  currentData.description_en = item.deskripsi_en;
  currentData.FotoUrl = item.foto_original ? item.foto : null;
  showImage.value = !!item.foto_original;

  dialog.value = true;
};

const deleteItem = (item) => {
  editedIndex.value = list_data.value.indexOf(item);
  editedItem.value = { ...item };
  dialogDelete.value = true;
};

const deleteItemConfirm = async () => {
  closeDelete();
  try {
    await LayananSuperiorService.delete(editedItem.value.id);
    CommonService.showSuccessToast("Hapus data layanan berhasil");
    resetCurrentData();
    getDataFromApi();
  } catch (err) {
    console.error(err);
    CommonService.showErrorToast("Hapus data layanan gagal. Coba lagi");
  }
};

const closePopUp = () => {
  dialog.value = false;
  showImage.value = false;
};

const closeDelete = () => {
  dialogDelete.value = false;
  nextTick(() => {
    editedItem.value = {};
    editedIndex.value = -1;
  });
};

// --- Watchers ---

watch(
  selected,
  (newValue) => {
    if (newValue?.length > 0) {
      childKey.value++;
    }
  },
  { deep: true },
);

watch(
  options,
  () => {
    if (isFirst.value) {
      getDataFromApi();
    }
  },
  { deep: true },
);

// --- Lifecycle Hooks ---

onMounted(() => {
  getDataFromApi();
});
</script>

<style scoped>
ul {
  list-style-type: none;
}
.actions-header {
  margin-right: 20px !important;
}
</style>
